import { SET_RECALL_SERVICES, CLEAR_SERVICES } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.recall, action) {
  switch (action.type) {
    case SET_RECALL_SERVICES:
      return action.payload;
    case CLEAR_SERVICES:
    case RESET_APP_STATE:
      return initialState.recall;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/recall/reducer.js